import { createFileRoute } from "@tanstack/react-router";
import { AuthPage } from "@/components/auth-page";

export const Route = createFileRoute("/sign-in")({
	component: SignInPage,
	ssr: false,
});

function SignInPage() {
	return <AuthPage view="SIGN_IN" />;
}
